import React from 'react';
import { Link } from 'react-router-dom';

const STATUS_LABELS = {
  pending_client_details: 'Pending Client Details',
  pending_risk_assessment: 'Pending Risk Assessment',
  pending_reviewer_review: 'Pending Review',
  accepted: 'Accepted',
  rejected: 'Rejected',
  expiringSoon: 'Expiring Soon',
  expired: 'Expired',
};

const formatDate = dateString => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  } catch {
    return '-';
  }
};

const formatType = type => {
  if (!type) return '';
  return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
};

const FormHeader = ({ clientData }) => {
  const dateStr = formatDate(clientData?.submitedDate || clientData?.updatedAt);
  const statusLabel = STATUS_LABELS[clientData?.formStatus] || clientData?.formStatus || '-';
  const typeLabel = formatType(clientData?.type);
  const nameWithType = clientData?.name ? (typeLabel ? `${clientData.name} (${typeLabel})` : clientData.name) : '-';

  return (
    <div className='max-w-6xl mx-auto rounded-t-lg border border-b-0 border-gray-200 bg-gray-50 px-4 py-3'>
      <div className='flex flex-wrap items-center justify-between gap-x-6 gap-y-2'>
        <div className='flex flex-wrap items-center gap-x-4 gap-y-2 min-w-0 flex-1'>
          <span className='font-medium text-gray-800 truncate' title={nameWithType}>
            {nameWithType}
          </span>
          <span className='text-gray-500 text-sm flex-shrink-0'>|</span>
          <span className='text-gray-600 text-sm flex-shrink-0'>Date: {dateStr}</span>
          <span className='text-gray-500 text-sm flex-shrink-0'>|</span>
          <span className='text-gray-600 text-sm flex-shrink-0'>Status: {statusLabel}</span>
        </div>
        <Link
          to='/kyc-aml/customer-list'
          className='flex-shrink-0 inline-flex items-center justify-center w-8 h-8 text-gray-500 hover:text-gray-800 hover:bg-gray-200 rounded transition-colors'
          aria-label='Back to list'
        >
          <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24' aria-hidden>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default FormHeader;
